import React from "react";
import LogoOption1 from "../components/logos/LogoOption1";
import LogoOption2 from "../components/logos/LogoOption2";
import LogoOption3 from "../components/logos/LogoOption3";

const OPTIONS = [
  {
    id: 1,
    Comp: LogoOption1,
    name: "Option 1 — Global Powerhouse Emblem",
    desc: "A bold circular medallion with a globe and a solid WWD monogram bar. Feels established, industrial and authoritative — great as a stamp/seal on trucks, pallets and paperwork.",
  },
  {
    id: 2,
    Comp: LogoOption2,
    name: "Option 2 — Freight Shield Crest",
    desc: "A shield crest with a globe and an upward growth arrow (turning inventory into capital). Conveys trust, strength and recovery — a corporate powerhouse look.",
  },
  {
    id: 3,
    Comp: LogoOption3,
    name: "Option 3 — Bold Monogram Block",
    desc: "A modern rounded-block mark with an integrated globe and a heavy \u2018W\u2019. Clean, confident and highly scalable for web, app icons and social avatars.",
  },
];

export default function LogoShowcase() {
  return (
    <main className="mx-auto max-w-6xl px-5 py-16 lg:px-8">
      <div className="text-center">
        <span className="text-sm font-bold uppercase tracking-wider text-teal-brand">Brand Concepts</span>
        <h1 className="mt-3 text-4xl font-extrabold text-navy-brand">Choose Your Logo</h1>
        <p className="mx-auto mt-4 max-w-2xl text-[15px] text-slate-500">
          Three powerhouse directions for World Wide Wholesale Deals LLC. Each is shown on light and
          dark backgrounds and as a standalone icon. Tell me the number you like and I’ll apply it
          across the entire site (and tweak colors/spacing if you want).
        </p>
      </div>

      <div className="mt-14 space-y-10">
        {OPTIONS.map(({ id, Comp, name, desc }) => (
          <div key={id} className="overflow-hidden rounded-3xl border border-slate-200 shadow-sm">
            <div className="flex items-center justify-between bg-slate-50 px-6 py-4">
              <h2 className="text-lg font-bold text-navy-brand">{name}</h2>
              <span className="rounded-full bg-teal-brand px-4 py-1 text-sm font-bold text-white">#{id}</span>
            </div>
            <div className="grid gap-0 md:grid-cols-3">
              {/* light */}
              <div className="flex items-center justify-center border-b border-slate-100 bg-white p-10 md:border-b-0 md:border-r">
                <Comp variant="dark" size={58} />
              </div>
              {/* dark */}
              <div className="flex items-center justify-center border-b border-slate-100 bg-navy-brand p-10 md:border-b-0 md:border-r">
                <Comp variant="light" size={58} />
              </div>
              {/* icon only + description */}
              <div className="flex flex-col items-center justify-center gap-4 p-8">
                <div className="flex gap-4">
                  <div className="flex h-20 w-20 items-center justify-center rounded-2xl bg-white shadow">
                    <Comp variant="dark" size={54} />
                  </div>
                </div>
                <p className="text-center text-xs leading-relaxed text-slate-500">{desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 rounded-2xl bg-teal-brand/10 p-6 text-center">
        <p className="text-sm font-medium text-navy-brand">
          Reply with <strong>“Option 1”, “Option 2” or “Option 3”</strong> and I’ll set it as the official logo everywhere.
        </p>
      </div>
    </main>
  );
}
